export interface DailyWeeklyCondition {
	isin: number[];
	time: string;
}

export interface ExecuteOnceAt {
	date: string;
	time: string;
}

export interface TimeBasedConditionsUI {
	id: number;
	value: DailyWeeklyCondition | ExecuteOnceAt | number;
	_gui_type: 'timer' | 'd_cond' | 'ot_cond';
}

export function is_time_based_cond(obj: any): obj is TimeBasedConditionsUI {
	return (
		typeof obj === 'object' &&
		typeof obj._gui_type === 'string' &&
		['timer', 'ot_cond', 'd_cond'].includes(obj._gui_type)
	);
}

export function is_execute_once(o): o is ExecuteOnceAt {
	return (
		typeof o === 'object' &&
		typeof o.date === 'string' &&
		o.date.length > 5 &&
		typeof o.time === 'string' &&
		o.time.length === 5
	);
}
export function is_daily_data(o): o is ExecuteOnceAt {
	return (
		typeof o === 'object' &&
		typeof o.isin === 'object' &&
		typeof o.isin.length !== 'undefined' &&
		o.isin.length > 0 &&
		typeof o.time === 'string' &&
		o.time.length === 5
	);
}
